module.exports = __webpack_public_path__ + "img/client_3.bca8b4e8.jpg";